import React from "react";
import BlogPosts from "../components/BlogPosts";

const Blog = () => {
    return (
        <div className="max-w-7xl mx-auto px-6 py-16">
            {/* ✅ SEO-Friendly Heading */}
            <header className="text-center mb-12">
                <h1 className="text-4xl font-extrabold text-blue-900 mb-3">
                    MM AutoTech Blog
                </h1>
                <p className="text-gray-600 max-w-2xl mx-auto text-lg">
                    Stay informed with our latest expert tips, automotive guides, and
                    service insights — helping you maintain your vehicle with confidence.
                </p>
            </header>

            {/* ✅ Blog Listing */}
            <BlogPosts />
        </div>
    );
};

export default Blog;
